import React from "react"

import styles from './styles/Whatsnew.module.css';
const ListOfFeatures=({featureList})=>{
   
    return (
      <div className={styles.featuresContainer}>
        {featureList.map((e, index) => (
          <div
            className={`${styles.feature} ${
              index !== featureList.length - 1 ? styles.withDivider : ''
            }`}
            key={index}
          >
            <img src={e.img} alt={e.text} />
            <p>{e.text}</p>
          </div>
        ))}
      </div>
    );

}
export default ListOfFeatures